import { ExtendableError } from 'ts-error';

export class ServiceException extends ExtendableError { }
